module.exports = __webpack_public_path__ + "gif/correct-9.gif";